import * as React from "react"
import {withStyles, WithStyles, StyleRules, ClassNameMap} from "@mui/styles"
import AppView from "~common/components/app-view/index"
import LoadingView from "~common/components/loading-view"
import {Theme} from "@mui/styles"
import Require from "~common/components/require"
import FaqEditView from "~faq/components/faq-edit-view"
import FaqQueryList from "~faq/components/faq-query-view"
import {Typography} from '@mui/material'




const styles = (theme: Theme): StyleRules => ({
  container: {
    width: "100%",
  },
})

interface Props extends React.HTMLProps<HTMLDivElement> {
  history: any
}

type State = {
  status: "loading" | "ready"
}

class FaqAdmin extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {})
    this.state = {status: "ready"}
  }

  render() {

    const {match} = this.props;
    const { classes, history}: {classes: ClassNameMap; history: any} = this.props
    const { status} = this.state
    var selectedFaqID
    if(match && match.params && match.params.id) {
      selectedFaqID = match.params.id
    }

    var view 
    if (status === "loading") {
      view = <LoadingView classes={{}} />
    } else if (selectedFaqID) {
      view = <FaqEditView match={match} faqId={selectedFaqID} history={history} classes={{}} />
    } else {
      view = <FaqQueryList></FaqQueryList> 
    }

    return (
      <AppView>
        <Require classes={{}} requireOneOfFeatures={["faq_admin"]}>
            <Typography id="faqAdminTitle" variant="h5" className={classes.heading}>
               Faq Administration
            </Typography>
            <div className={classes.container}>{view}</div>
        </Require>
      </AppView>
    )
  }
}

export default withStyles(styles)(FaqAdmin)
